import { useLocation } from 'react-router';

const ONBOARDING_BASE_PATH = '/dashboard/merchant/setup';
const ONBOARDING_BASE_PATH_TWO = '/settings/locations/franchise';
const ONBOARDING_CONNECT_PATH = '/dashboard/locations/franchise/connect';
const EXCLUDED_ONBOARDING_PATHS = [`${ONBOARDING_BASE_PATH_TWO}/invite/list`, `${ONBOARDING_BASE_PATH_TWO}/page-not-found`];

export const useIsInOnboardingFlow = () => {
  const { pathname } = useLocation();
  return (
    pathname.startsWith(ONBOARDING_BASE_PATH) ||
    (pathname.startsWith(ONBOARDING_BASE_PATH_TWO) && !EXCLUDED_ONBOARDING_PATHS.includes(pathname)) ||
    pathname.startsWith(ONBOARDING_CONNECT_PATH)
  );
};
